<template>
    <layout :breadcrumbs="breadcrumbs">
        <template slot="header">
            <h1 class="text-center">
                Shop by Payment
            </h1>
        </template>
        <b-row id="shop-by-payment">
            <div class="col-12 col-md-9">
                <h2 class="price-sub-title mb-0">
                    What is your desired monthly payment?
                </h2>
                <!--Desktop Slider-->
                <div
                    class="row d-none d-md-flex justify-content-center align-items-center h-50"
                >
                    <div
                        class="col-12 col-md d-flex justify-content-center justify-content-md-end"
                    >
                        <span>$0</span>
                    </div>

                    <vue-slider-component
                        ref="priceSlider"
                        v-model="paymentRange"
                        class="col-12 col-md-8"
                        v-bind="desktopSliderOptions"
                        @callback="onDragEnd"
                    >
                        <template slot="tooltip" slot-scope="{ index, value }">
                            <div
                                class="diy-tooltip d-flex flex-column justify-content-center align-items-center"
                            >
                                <small v-if="index === 0" class="mb-1">
                                    starting at
                                </small>
                                <small v-if="index === 1" class="mb-1">
                                    up to
                                </small>
                                <div v-if="index === 0 || index === 1">
                                    <div v-if="index === 0" class="price">
                                        {{ value | numeral("$0,0") }}/mo
                                    </div>
                                    <div v-if="index === 1" class="price">
                                        {{ value | numeral("$0,0") }}/mo
                                    </div>
                                </div>

                                <div v-else class="merged-price">
                                    <span v-if="value[0] === value[1]">
                                        {{ value[0] | numeral("$0,0") }}/mo
                                    </span>
                                    <span v-else>
                                        {{ value[0] | numeral("$0,0") }} -
                                        {{ value[1] | numeral("$0,0") }}/mo
                                    </span>
                                </div>
                            </div>
                        </template>
                    </vue-slider-component>
                    <div
                        class="col-12 col-md d-flex justify-content-center justify-content-md-start"
                    >
                        <span>$1,500 +</span>
                    </div>
                </div>
                <!--Mobile Slider-->
                <div
                    class="row d-flex d-md-none justify-content-center align-items-center"
                >
                    <div
                        class="col-12 col-md d-flex justify-content-center justify-content-md-start m-2"
                    >
                        <span>$1,500 +</span>
                    </div>
                    <vue-slider-component
                        ref="priceSlider"
                        v-model="paymentRange"
                        v-bind="mobileSliderOptions"
                        @callback="onDragEnd"
                    >
                        <template slot="tooltip" slot-scope="{ index, value }">
                            <div
                                class="diy-tooltip d-flex flex-column justify-content-center align-items-center"
                            >
                                <small v-if="index === 0" class="mb-1">
                                    starting at
                                </small>
                                <small v-if="index === 1" class="mb-1">
                                    up to
                                </small>
                                <div v-if="index === 0 || index === 1">
                                    <div v-if="index === 0" class="price">
                                        {{ value | numeral("$0,0") }}/mo
                                    </div>
                                    <div v-if="index === 1" class="price">
                                        {{ value | numeral("$0,0") }}/mo
                                    </div>
                                </div>

                                <div v-else class="merged-price">
                                    <span v-if="value[0] === value[1]">
                                        {{ value[0] | numeral("$0,0") }}/mo
                                    </span>
                                    <span v-else>
                                        {{ value[0] | numeral("$0,0") }} -
                                        {{ value[1] | numeral("$0,0") }}/mo
                                    </span>
                                </div>
                            </div>
                        </template>
                    </vue-slider-component>
                    <div
                        class="col-12 col-md d-flex justify-content-center justify-content-md-end m-2"
                    >
                        <span>$0</span>
                    </div>
                </div>

                <div class="d-flex justify-content-center">
                    <b-form-radio-group
                        id="paymentType"
                        v-model="paymentType"
                        :options="paymentTypeOptions"
                    />
                </div>
            </div>

            <selected-filters :route-to="next" />
        </b-row>
    </layout>
</template>
<script>
import { dispatch, get } from "vuex-pathify";
import _ from "lodash";
import VueSliderComponent from "vue-slider-component";
import SelectedFilters from "../components/SelectedFilters";
import Layout from "../components/Layout";
import dot from "../Price/images/slider-dot.png";

export default {
    components: { Layout, SelectedFilters, VueSliderComponent },

    data() {
        return {
            paymentRange: [0, 1500],
            paymentType: "ALL",
            breadcrumbs: [
                {
                    text: "Shop By",
                    href: "/shop-by"
                },
                {
                    text: "Payment",
                    active: true
                }
            ],
            paymentTypeOptions: [
                {
                    text: "All",
                    value: "ALL"
                },
                {
                    text: "Lease",
                    value: "LEASE"
                },
                {
                    text: "Finance",
                    value: "FINANCE"
                }
            ],
            desktopSliderOptions: {
                min: 0,
                max: 1500,
                interval: 50,
                dotSize: 40,
                bgStyle: {
                    backgroundColor: "#E6E6E6"
                },
                sliderStyle: {
                    backgroundImage: `url(${dot})`,
                    "background-color": "transparent",
                    "background-size": "cover",
                    "box-shadow": "none",
                    "border-radius": "0"
                },
                tooltipMerge: true
            },
            mobileSliderOptions: {
                min: 0,
                max: 1500,
                interval: 50,
                dotSize: 40,
                width: 6,
                height: 320,
                bgStyle: {
                    backgroundColor: "#E6E6E6"
                },
                sliderStyle: {
                    backgroundImage: `url(${dot})`,
                    "background-color": "transparent",
                    "background-size": "cover",
                    "box-shadow": "none",
                    "border-radius": "0"
                },
                tooltipMerge: true,
                direction: "vertical"
            }
        };
    },
    computed: {
        next() {
            return {
                href: _.get(this.$route.meta, "next.href"),
                to: _.get(this.$route.meta, "next.to"),
                modelsPage: _.get(this.$route.meta, "next.modelsPage", false)
            };
        },
        minPayment: get("shopBy/minPaymentFilter"),
        maxPayment: get("shopBy/maxPaymentFilter")
    },

    watch: {
        paymentType(newVal) {
            if (newVal === "ALL") {
                dispatch("shopBy/removeFilter", "paymentType");
            } else {
                dispatch("shopBy/addFilters", [
                    {
                        name: "paymentType",
                        value: newVal
                    }
                ]);
            }
        },
        minPayment(newVal) {
            if (_.isNil(newVal)) {
                this.$refs.priceSlider.setValue([0, this.paymentRange[1]]);
            } else if (newVal.value !== this.paymentRange[0]) {
                this.$refs.priceSlider.setValue([
                    newVal.value,
                    this.paymentRange[1]
                ]);
            }
        },
        maxPayment(newVal) {
            if (_.isNil(newVal)) {
                this.$refs.priceSlider.setValue([this.paymentRange[0], 1500]);
            } else if (newVal.value !== this.paymentRange[1]) {
                this.$refs.priceSlider.setValue([
                    this.paymentRange[0],
                    newVal.value
                ]);
            }
        }
    },

    created() {
        this.paymentType = _.get(this.$route.query, "paymentType", "ALL");
        dispatch("shopBy/setSort", "quote.monthlyPayment,asc");
    },

    methods: {
        onDragEnd() {
            const filters = [];

            if (this.paymentRange[0] === 0) {
                dispatch("shopBy/removeFilter", "minPayment");
            }

            if (this.paymentRange[1] === 1500) {
                dispatch("shopBy/removeFilter", "maxPayment");
            }

            if (this.paymentRange[0] > 0) {
                filters.push({
                    name: "minPayment",
                    value: this.paymentRange[0]
                });
            }

            if (this.paymentRange[1] < 1500) {
                filters.push({
                    name: "maxPayment",
                    value: this.paymentRange[1]
                });
            }

            if (filters.length > 0) {
                dispatch("shopBy/addFilters", filters);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
#shop-by-payment {
    .price-title {
        font-size: px2rem(28);
        color: $dark-gray;
        line-height: 25px;
        padding: 45px 0 25px 0;
    }

    .price-sub-title {
        font-size: px2rem(24);
        padding: 35px 0 35px 35px;
    }

    .price {
        font-size: px2rem(16);
        border: 1px solid $primary-blue;
        border-radius: 20px;
        background-color: $very-light-gray;
        padding: 3px 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 95px;
    }

    .price:before {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top-color: inherit;
        transform: translate(-50%);
    }

    .merged-price {
        font-size: px2rem(16);
        border: 1px solid $primary-blue;
        border-radius: 20px;
        background-color: $very-light-gray;
        min-width: 155px;
        min-height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .merged-price:before {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top-color: inherit;
        transform: translate(-50%);
    }

    @include media-breakpoint-down(sm) {
        .price-sub-title {
            padding: 0;
        }

        .price:before {
            bottom: unset !important;
            left: unset !important;
            top: 30px !important;
            right: -9px !important;
            transform: rotate(-90deg) !important;
        }

        .merged-price:before {
            bottom: unset !important;
            left: unset !important;
            top: 11px !important;
            right: -9px !important;
            transform: rotate(-90deg) !important;
        }
    }
}
</style>
